import { type IDiscountTargetCriteria } from '@mahawi/eshop-common/src/types';
import { createSlice } from '@reduxjs/toolkit';

import {
  asyncStateInitial,
  finishLoading,
  requestFailedMatcher,
  resetLoadingOnRequestFailed,
  startLoading,
} from '../async-state';
import {
  type ICrmCustomersState,
  type ICustomerAdmin,
  type ICustomerSearchResult,
} from './types';

export const preloadedState: ICrmCustomersState = {
  ...asyncStateInitial,
  customers: undefined,
  searchResults: undefined,
  segmentPreviewResults: undefined,
};

const crmCustomersSlice = createSlice({
  name: 'CrmCustomers',
  initialState: preloadedState,
  reducers: {
    crmCustomersLoadAll(state) {
      startLoading(state);
    },
    crmCustomersLoadAllResponse: {
      reducer(state, action: { payload: { customers: ICustomerAdmin[] } }) {
        state.customers = action.payload.customers;
        finishLoading(state);
      },
      prepare(customers: ICustomerAdmin[]) {
        return { payload: { customers } };
      },
    },
    customerSearch: {
      reducer(state) {
        startLoading(state);
      },
      prepare(query: string) {
        return { payload: { query } };
      },
    },
    customerSearchResponse: {
      reducer(
        state,
        action: { payload: { customers: ICustomerSearchResult[] } },
      ) {
        state.searchResults = action.payload.customers;
        finishLoading(state);
      },
      prepare(customers: ICustomerSearchResult[]) {
        return { payload: { customers } };
      },
    },
    discountSegmentPreview: {
      reducer(state) {
        startLoading(state);
      },
      prepare(criteria: IDiscountTargetCriteria) {
        return { payload: { criteria } };
      },
    },
    discountSegmentPreviewResponse: {
      reducer(
        state,
        action: { payload: { customers: ICustomerSearchResult[] } },
      ) {
        state.segmentPreviewResults = action.payload.customers;
        finishLoading(state);
      },
      prepare(customers: ICustomerSearchResult[]) {
        return { payload: { customers } };
      },
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      requestFailedMatcher('CrmCustomers'),
      resetLoadingOnRequestFailed,
    );
  },
});

export const {
  crmCustomersLoadAll,
  crmCustomersLoadAllResponse,
  customerSearch,
  customerSearchResponse,
  discountSegmentPreview,
  discountSegmentPreviewResponse,
} = crmCustomersSlice.actions;
export default crmCustomersSlice.reducer;
